// firebase.jsx
import React from "react";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage, deleteToken } from "firebase/messaging";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as apiUtenti from "../../api/users";

const firebaseConfig = {
  apiKey: "AIzaSyCdt7jfenAvp3VOT7UTSKJEyUhmV2Y93sA",
  authDomain: "portale-agenti-6f5df.firebaseapp.com",
  projectId: "portale-agenti-6f5df",
  storageBucket: "portale-agenti-6f5df.firebasestorage.app",
  messagingSenderId: "842406080827",
  appId: "1:842406080827:web:0431bb3e5478ae57f7871e",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Inizializza messaging solo se supportato (evita crash su HTTP/IP locale)
let messaging = null;
try {
  messaging = getMessaging(app);
} catch (err) {
  console.warn("Firebase Messaging initialization failed (likely due to insecure context/HTTP):", err);
}

export const checkNotificationPermission = () => {
  if (!("Notification" in window)) return "not-supported";
  return Notification.permission;
};

export const requestNotificationPermission = async () => {
  if (!("Notification" in window)) {
    alert("Le notifiche non sono supportate");
    return false;
  }

  if (Notification.permission === "denied") {
    alert("Le notifiche sono bloccate. Modifica le impostazioni del browser.");
    return false;
  }

  const permission = await Notification.requestPermission();
  return permission === "granted";
};

export const requestForToken = async (authToken = null, forceRefresh = false) => {
  if (!messaging) {
    console.warn("Firebase Messaging non disponibile.");
    return null;
  }

  if (checkNotificationPermission() !== "granted") return null;

  try {
    let tokenOptions = {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    };

    if ('serviceWorker' in navigator) {
      // Registra sempre esplicitamente per assicurarsi che ci sia il SW per le notifiche
      try {
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        tokenOptions.serviceWorkerRegistration = registration;
      } catch (error) {
        console.error('Firebase SW registration failed:', error);
      }
    }

    if (forceRefresh) {
      console.log("Forcing token refresh...");
      try {
        await deleteToken(messaging);
        console.log("Token deleted successfully.");
      } catch (e) {
        console.warn("Failed to delete token:", e);
      }
    }

    const currentToken = await getToken(messaging, tokenOptions);
    if (currentToken) {
      console.log("🔥 FCM Token:", currentToken);
      if (authToken) {
        await apiUtenti.updateFcmToken(authToken, { fcmToken: currentToken });
      }
    }
    return currentToken;
  } catch (err) {
    console.error("Errore recupero token:", err);
    return null;
  }
};

const ToastWithTitle = ({ title, body, type = "default" }) => (
  <div style={{ padding: '8px 12px' }}>
    <div style={{ fontWeight: 'bold', color: type === 'error' ? '#d32f2f' : 'inherit' }}>
      {title}
    </div>
    <div>{body}</div>
  </div>
);

const showToast = ({ title, body, type = 'default', ...options }) => {
  const content = (
    <div>
      <div style={{ fontWeight: 'bold' }}>{title}</div>
      <div>{body}</div>
    </div>
  );

  switch (type) {
    case 'success': return toast.success(content, options);
    case 'error': return toast.error(content, options);
    case 'warning': return toast.warning(content, options);
    case 'info': return toast.info(content, options);
    default: return toast(content, options);
  }
};


// ✅ CORRETTO: onMessage con messaging come primo argomento
if (messaging) {
  onMessage(messaging, (payload) => {
    console.log("Messaggio in foreground (data-only):", payload);

    const data = payload.data || {};
    const title = data.title || "Nuova notifica";
    const body = data.body || "";

    showToast({
      title: title,
      body: body,
      type: "success",
      icon: "🔔",
      position: "bottom-center",
      style: {
        backgroundColor: '#ffffff',
        border: '1px solid #dee2e6',
        borderRadius: '8px',
        padding: '15px',
        maxWidth: '480px',
        minWidth: '480px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        zIndex: 9999
      }
  });

    // Mostra solo un toast (esperienza in-app)
    // toast.success(
    //   `${title.toLocaleUpperCase()}  ${body}`, {
    //   icon: "🔔",
    //   toastId: "fcm-foreground",
    //   position: "bottom-center",
    //   autoClose: 8000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    // });
  });
}

export { messaging };
